import { Link, useLocation } from 'react-router-dom';
import { CalendarDays, Calendar, LayoutDashboard, LogOut, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Layout({ children, user, onLogout }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/coagenda-logo.png" alt="CoAgenda" style={{ width: '140px', height: 'auto' }} />
        </div>

        <nav>
          <ul className="sidebar-nav">
            <li className="sidebar-nav-item">
              <Link
                to="/dashboard"
                className={`sidebar-nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                data-testid="nav-dashboard"
              >
                <LayoutDashboard size={20} />
                Dashboard
              </Link>
            </li>
            <li className="sidebar-nav-item">
              <Link
                to="/calendars"
                className={`sidebar-nav-link ${isActive('/calendars') ? 'active' : ''}`}
                data-testid="nav-calendars"
              >
                <Calendar size={20} />
                Calendários
              </Link>
            </li>
            <li className="sidebar-nav-item">
              <Link
                to="/events"
                className={`sidebar-nav-link ${isActive('/events') ? 'active' : ''}`}
                data-testid="nav-events"
              >
                <CalendarDays size={20} />
                Eventos
              </Link>
            </li>
            {user?.is_admin && (
              <li className="sidebar-nav-item">
                <Link
                  to="/admin"
                  className={`sidebar-nav-link ${isActive('/admin') ? 'active' : ''}`}
                  data-testid="nav-admin"
                >
                  <Shield size={20} />
                  Administração
                </Link>
              </li>
            )}
          </ul>
        </nav>

        <div className="sidebar-user">
          <div style={{ marginBottom: '1rem' }}>
            <div style={{ fontWeight: 600, color: '#0f172a', marginBottom: '0.25rem' }}>{user?.nome}</div>
            <div style={{ fontSize: '0.85rem', color: '#64748b' }}>{user?.email}</div>
          </div>
          <Button
            variant="ghost"
            onClick={onLogout}
            className="w-full justify-start"
            data-testid="logout-button"
            style={{ color: '#ef4444' }}
          >
            <LogOut size={18} style={{ marginRight: '0.5rem' }} />
            Sair
          </Button>
        </div>
      </aside>

      <main className="main-content">{children}</main>
    </div>
  );
}
